import { CONTEXTS } from '@/const'

/**
 * To learn more about Link Resolving check out the Prismic documentation
 */
function removeContext(uid) {
  for (const context of CONTEXTS) {
    if (uid.endsWith(`-${context}`)) {
      uid = uid.slice(0, -2)
    }
  }

  return uid
}

function getContext(uid) {
  let s = 'h'

  for (const context of CONTEXTS) {
    if (uid.endsWith(`-${context}`)) {
      s = uid.slice(-1)
      break
    }
  }

  return s
}

function linkResolver(doc) {
  const uid = doc.uid && doc.type !== 'page' ? removeContext(doc.uid) : doc.uid

  if (doc.isBroken) {
    return '/not-found'
  }

  switch (doc.type) {
    case 'accueil':
      return '/'
    case 'product':
      return `/products/${uid}`
    case 'questionnaire':
      return `/questionnaires/${uid}`
    case 'collection':
      if (uid === 'home') {
        return '/'
      }
      return `/collections/${uid}`
    case 'page':
      return `/pages/${uid}`
    case 'blog':
      return `/blogs/${uid}`
    case 'article':
      if (doc.tags && doc.tags.length > 0 && doc.tags.includes('guides')) {
        return `/blogs/guides-dentretien/${uid}`
      }
      return `/blogs/news/${uid}`
    default:
      return '/not-found'
  }
}

export function linkResolverWithContext(doc) {
  return `${getContext(doc.uid)}/${linkResolver(doc)}`
}

export default linkResolver
